<ng-container screenAnalytics="location-edit">
    <div class="modal-header">
        <div class="panel-heading-icon">
            <img imgPath="/icons/icon-locations.png" />
        </div>
        <h3 class="modal-title">{{ locationId ? 'Edit' : 'Add' }} Location</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="formGroup">
        <div class="modal-body horizontal-container max-height no-padding">
            <location-edit-drawing
                #drawingComponent
                [featureGroups]="featureGroups"
                [organisationId]="organisationId"
                [showAirspaceChecker]="true"
                [showNotices]="true"
                [type]="type"
                [missionValues]="missionValues"
                [workTracker]="workTracker"
                [airspaceValue$]="airspaceValue$"
                [mapData$]="mapData$"
                [currentTimeZone]="currentTimeZone"
                [mapJurisdiction]="mapJurisdiction"
                [showAirspaceDisclaimer]="showAirspaceDisclaimer"
                (featureGroupsChange)="onFeatureGroupsChange($event)"
                (hasRequiredFeaturesChange)="
                    onHasRequiredFeaturesChange($event)
                "
                (hasAnyFeaturesChange)="onHasAnyFeaturesChange($event)"
                (flightAreaChange)="onFlightAreaChange($event)"
                (geocodeResultSelected)="onGeocodeResultSelected($event)"
                (viewportChange)="onViewportChange($event)"
                (jurisdictionChanged)="onMapJurisdictionChanged($event)"
                (airspaceValuesUpdated)="onAirspaceValuesUpdated($event)"
                (airspaceDisclaimerAcknowledged)="
                    onAirspaceDisclaimerAcknowledged()
                "
                (editModeChanged)="onEditModeChanged($event)"
                (isAddingFeatureChange)="onIsAddingFeatureChange($event)"
                (isEditingChange)="onIsEditingChange($event)"
            ></location-edit-drawing>
        </div>

        <div class="modal-footer">
            <div class="horizontal-container fill verical-align">
                <div class="fill form-flex">
                    <label>Name&nbsp;</label>
                    <input
                        type="text"
                        class="form-control"
                        (keyup)="$event.stopPropagation()"
                        formControlName="name"
                    />
                </div>

                <div>
                    <button
                        [disabled]="!hasAnyFeatures"
                        class="btn btn-link"
                        type="button"
                        (click)="downloadKml()"
                        analyticsOn
                        analyticsAction="download-kml"
                    >
                        Download KML
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        ngfSelect
                        multiple="false"
                        accept="application/vnd.google-earth.kml\+xml,application/vnd.google-earth.kmz,application/zip,.kml,.kmz,application/x-zip-compressed,application/json,.json"
                        (fileChange)="uploadLocation($event)"
                        placement="top"
                        tooltip="Upload KML, KMZ, UgCS mission plan or Shape files (as a zip)"
                        enhancedHelp="upload-geometry"
                    >
                        Upload Geometry
                    </button>
                    <button
                        *ngIf="canCreateMission && missionValues == null"
                        type="button"
                        class="btn btn-default"
                        analyticsOn
                        analyticsAction="create-mission"
                        [disabled]="
                            formGroup.invalid ||
                            !hasRequiredFeatures ||
                            working ||
                            isAddingFeature
                        "
                        (click)="createMission()"
                    >
                        Create Mission
                    </button>
                    <button
                        class="btn btn-primary relative"
                        type="button"
                        (click)="save()"
                        [disabled]="
                            formGroup.invalid ||
                            !hasRequiredFeatures ||
                            working ||
                            isAddingFeature
                        "
                    >
                        Save
                        <!-- Provide contextual tooltips for the disabled states if not working -->
                        <span
                            class="overlay"
                            [tooltip]="
                                formGroup.invalid
                                    ? 'Enter a valid name for this location'
                                    : !hasRequiredFeatures
                                    ? 'Locations require at least one flight area or corridor'
                                    : isAddingFeature
                                    ? 'Please finish adding the current map feature before saving'
                                    : undefined
                            "
                            placement="left"
                        ></span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</ng-container>
